import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
import { IData, IItems, IState } from "../types";
import { defaultFormData, initialState } from "./initialState";

export const useClinicSlice = createSlice({
  name: "shippingState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setItemsLoading: (state, action: PayloadAction<boolean>) => {
      state.itemsLoading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },
    setToggleLoading: (state, action: PayloadAction<boolean>) => {
      state.toggleLoading = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      state.totalRow = action.payload;
    },

    setOrderDir: (state, action: PayloadAction<string>) => {
      state.orderDir = action.payload;
    },
    setOrderBy: (state, action: PayloadAction<string>) => {
      state.orderBy = action.payload;
    },

    updateFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `formData.${action.payload.key}`, action.payload.value);
    },

    clearFrom: (state) => {
      state.formData = { ...defaultFormData };
    },
    clearItemsFrom: (state) => {
      state.formData.priceItemsForm = { ...defaultFormData.priceItemsForm };
    },
    setItemsFromData: (state, action: PayloadAction<IItems>) => {
      state.formData.priceItems.push(action.payload);
    },

    doCreate: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doUpdate: (state, action: PayloadAction<{ callback: () => void }>) => {},
    doDelete: (
      state,
      action: PayloadAction<{ id: string; index: number; callback: () => void }>
    ) => {
      state.list.splice(action.payload.index, 1);
    },
    doCreateItems: (
      state,
      action: PayloadAction<{ callback: () => void }>
    ) => {},
    doUpdateItems: (
      state,
      action: PayloadAction<{
        index: number;
        data: IItems;
        callback: () => void
      }>
    ) => {},
    updateItemsFromData: (
      state,
      action: PayloadAction<{
        index: number;
        data: IItems;
      }>
    ) => {
      const { index, data } = action.payload;
      if (state.formData.priceItems[index]) {
        state.formData.priceItems[index] = {
          ...state.formData.priceItems[index],
          ...data,
        };
      }
    },
    doRemoveItems: (
      state,
      action: PayloadAction<{
        index: number;
      }>
    ) => {
      const items = state.formData.priceItems;

      if (
        items[action.payload.index] &&
        //@ts-ignore
        items[action.payload.index]?.["_id"]?.length > 0
      ) {
        items[action.payload.index].remove = true;
      } else {
        items.splice(action.payload.index, 1);
      }
    },

    doGetById: (state, action: PayloadAction<string>) => {
      state.loading = true;
    },
    doGetStateList: (state) => {},
    setStateList: (state, action: PayloadAction<IState[]>) => {
      state.stateList = action.payload;
    },
    doGetList: (state) => {
      if (!state.toggleLoading) {
        state.loading = true;
      }
    },
    setList: (state, action: PayloadAction<Array<IData>>) => {
      state.list = action.payload;
    },
    setDataForm: (state, action: PayloadAction<IData>) => {
      state.formData = action.payload;
    },
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
